import { render, staticRenderFns } from "./HeaderInvoiceReturnComponent.vue?vue&type=template&id=30abd5d4"
import script from "./HeaderInvoiceReturnComponent.vue?vue&type=script&lang=js"
export * from "./HeaderInvoiceReturnComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports